import $api from 'http'

//API для получения алертов

export async function getNotesData(notes) {
  return $api.get(`/notes/`, notes)
}
export async function deleteNotes(id) {
  return $api.delete(`/notes/${id}/`);
}
export async function PostNotes(formdata) {
  return $api.post(`/notes/`, formdata ,{
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }); 
}

export async function getNotes(id) {
  return $api.get(`/notes/${id}/`);
}

export async function patchNotes(id) {
  return $api.patch(`/notes/${id}/`);
}

export async function patchNotesData(id, data) {
  return $api.patch(`/notes/${id}/`, {"body":data});
}

export async function patchNotesTitleData(id, data) {
  return $api.patch(`/notes/${id}/`, {"title":data});
}


